import { cn } from "@/lib/cn";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumb?: string[];
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader = ({
  title,
  subtitle,
  breadcrumb,
  actions,
  className,
}: PageHeaderProps) => (
  <header
    data-testid="page-header"
    className={cn(
      "flex flex-col gap-4 border-b border-border pb-5 sm:flex-row sm:items-end sm:justify-between",
      className,
    )}
  >
    <div className="min-w-0">
      {breadcrumb && breadcrumb.length > 0 && (
        <nav data-testid="page-header-breadcrumb" className="ops-label mb-2 flex flex-wrap items-center gap-1.5">
          {breadcrumb.map((crumb, i) => (
            <span key={crumb} className="flex items-center gap-1.5">
              {i > 0 && <span className="opacity-40">/</span>}
              {crumb}
            </span>
          ))}
        </nav>
      )}
      <h1
        data-testid="page-header-title"
        className="truncate text-2xl font-semibold tracking-tight sm:text-3xl"
      >
        {title}
      </h1>
      {subtitle && (
        <p data-testid="page-header-subtitle" className="mt-1.5 text-sm text-muted-foreground">
          {subtitle}
        </p>
      )}
    </div>
    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
  </header>
);
